import { render, staticRenderFns } from "./constantes.html?vue&type=template&id=5b422856&scoped=true&external"
import script from "./constantes.js?vue&type=script&lang=js&external"
export * from "./constantes.js?vue&type=script&lang=js&external"
import style0 from "./constantes.scss?vue&type=style&index=0&id=5b422856&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b422856",
  null
  
)

export default component.exports